import Vue from 'vue';
import Router from 'vue-router';
import { baseRouterList } from '@/router/base';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: baseRouterList
});

router.$addRoutes = (params) => {
    router.matcher = new Router({routes:[]}).matcher;
    router.addRoutes(params);
};

export default router;